module.exports = __webpack_public_path__ + "img/icon-empty.afe4955f.png";